module.exports = __webpack_public_path__ + "static/media/Little_Buddies_square.3c9d571f.png";